"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Tag = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M3.451 9.633L3.5 3.726c.005-.099.128-.222.253-.227l5.88-.048c.33-.014.837.184 1.052.398l9.54 9.54a1.11 1.11 0 0 1 0 1.572l-5.263 5.263a1.11 1.11 0 0 1-1.571 0l-9.54-9.54c-.215-.215-.413-.721-.4-1.025l.001-.026zm-1.499-.039c-.031.724.325 1.639.837 2.151l9.54 9.54a2.61 2.61 0 0 0 3.692 0l5.264-5.264a2.61 2.61 0 0 0 0-3.692l-9.54-9.54c-.512-.512-1.427-.868-2.15-.837l-5.882.047C2.785 2.04 2.04 2.785 2 3.687L1.951 9.62l.001-.027zM6.7 8.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z", children: " " })
] });
var Tag_default = Tag;
export {
  Tag_default as default
};
